import { APPLICATION_KO_ORGANIZATIO_ID, APPLICATION_TYPE } from "../constants/constants"
import { safeStorage } from "./safeStorage"

/**
 * Header, die JEDER Request an das Backend trägt — eine Quelle für den
 * Apollo-Client (ApolloWrapper) und den Apollo-freien Meldepfad
 * (services/reportEndUserEvent). Divergieren die beiden, landen Meldungen
 * beim falschen Tenant oder ohne Anwendungstyp.
 *
 * Phase 2: x-ko-organization-id nur senden, wenn explizit gesetzt (lokale
 * Entwicklung) oder zur Laufzeit bekannt (Embed). Im iFrame erkennt das Backend
 * den Tenant über den Origin.
 */
export const buildStaticHeaders = (): Record<string, string> => {
    const organizationId = runtimeOrganizationId || APPLICATION_KO_ORGANIZATIO_ID
    return {
        "x-application-type": APPLICATION_TYPE ?? "end-user-app",
        ...(organizationId ? { "x-ko-organization-id": organizationId } : {}),
    }
}

// Embed-Modus (sc-3381): Dort ist der Origin die Kundenseite, daran erkennt das Backend den Tenant nicht.
// src/embed/index.tsx liest die ID vor dem Start aus /embed/tenant.json des App-Hosts und setzt sie hier.
let runtimeOrganizationId: string | undefined

export const setRuntimeOrganizationId = (organizationId: string): void => {
    runtimeOrganizationId = organizationId
}

/** Auth-Token der End-User-App aus dem Storage; leere Strings, wenn nicht eingeloggt. */
export const buildAuthHeaders = (): Record<string, string> => {
    const accessToken = safeStorage.getItem("accessToken")
    const refreshToken = safeStorage.getItem("refreshToken")
    return {
        "access-token-end-user-app": accessToken ? `${accessToken}` : "",
        "refresh-token-end-user-app": refreshToken ? `${refreshToken}` : "",
    }
}
